import React from 'react'

function TopDestinationsLinks(props) {
  return (
    <div className="flex flex-1 flex-col bg-stone-100 p-0">
      <ul className="list-none p-0">
        {Object.keys(props).map((index) => {
          const location = props[index]
          return (
            <li
              className="whitespace-nowrap py-1 text-base font-normal text-gray-1100"
              key={location.slug}
            >
              <a
                className="underline"
                title={location?.linkTitle}
                href={`/${location.slug}/`}
              >
                {location.title}
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default TopDestinationsLinks
